var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('transition',{attrs:{"name":"fade-transition"}},[_c('MyExamsComponent',{attrs:{"get-url":"/exams/results"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }